import { render, staticRenderFns } from "./detailStaffLeave.vue?vue&type=template&id=26582cf4&scoped=true&"
import script from "./detailStaffLeave.vue?vue&type=script&lang=js&"
export * from "./detailStaffLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26582cf4",
  null
  
)

export default component.exports